import { makeAutoObservable, runInAction } from "mobx";
import { FeatureCollection } from "geojson";
import { RootStore } from "../../shared/stores/RootStore";

export class RouteDesignStore {
  rootStore;

  selectedFeatureIds: string[] = [];
  newPlannedTrajectory: FeatureCollection | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  resetState() {
    runInAction(() => {
      this.newPlannedTrajectory = null;
    });
  }

  setNewPlannedTrajectory(value: FeatureCollection | null) {
    runInAction(() => {
      this.newPlannedTrajectory = value;
    });
  }

  setSelectedFeatureIds(value: string[]) {
    runInAction(() => {
      this.selectedFeatureIds = value;
    });
  }
}
